"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getZrxMinMax = void 0;
const chain_adapters_1 = require("@shapeshiftoss/chain-adapters");
const api_1 = require("../../../api");
const bignumber_1 = require("../../utils/bignumber");
const constants_1 = require("../utils/constants");
const helpers_1 = require("../utils/helpers/helpers");
const getZrxMinMax = async (sellAsset, buyAsset) => {
    try {
        if (!((0, chain_adapters_1.isEvmChainId)(sellAsset.chainId) &&
            (0, chain_adapters_1.isEvmChainId)(buyAsset.chainId) &&
            buyAsset.chainId === sellAsset.chainId)) {
            throw new api_1.SwapError('[getZrxMinMax]', { code: api_1.SwapErrorTypes.UNSUPPORTED_PAIR });
        }
        const usdRate = await (0, helpers_1.getUsdRate)({ ...sellAsset });
        const minimum = (0, bignumber_1.bn)(1).dividedBy((0, bignumber_1.bnOrZero)(usdRate)).toString(); // $1 worth of the sell token.
        const maximum = constants_1.MAX_ZRX_TRADE; // Arbitrarily large value. 10e+28 here.
        return {
            minimum,
            maximum,
        };
    }
    catch (e) {
        if (e instanceof api_1.SwapError)
            throw e;
        throw new api_1.SwapError('[getZrxMinMax]', { cause: e, code: api_1.SwapErrorTypes.MIN_MAX_FAILED });
    }
};
exports.getZrxMinMax = getZrxMinMax;
